const getPercent = (ev) => {
    const total = ev.total
    const loaded = ev.loaded
    let percent = total && loaded ? Math.round((loaded * 100) / total) : -1
    return percent
}

const addProgress = (config, opts) => {

    if (opts.progressCb) {
        if (!opts.noPercent) {
            config.onUploadProgress = ev => {
                const percent = getPercent(ev)
                opts.progressCb(percent, opts.file)
            }
            config.onDownloadProgress = ev => {
                const percent = getPercent(ev)
                opts.progressCb(percent, opts.file)
            }
        }

        if (opts.hasStatic) {
            opts.progressCb(-1, opts.file)
        }
    }
}

const getConfig = (axiosConfig) => {
    const cancelTokenSource = axios.CancelToken.source()
    const config = {
        cancelToken: cancelTokenSource.token,
        ...axiosConfig || {}
    }
    return {config, cancelTokenSource}
}

export default {
    store: (opts, url) => {
        opts = {
            post_id: undefined,
            group: null,
            file: null,
            progressCb: null,
            ...opts,
        }

        const form = new FormData()

        const toForm = [
            'post_id',
            'group',
            'file'
        ]
        toForm.filter(k => opts[k]).forEach(k => form.append(k, opts[k]))

        const {config, cancelTokenSource} = getConfig()

        addProgress(config, {...opts, hasStatic: true})
        return {
            promise: axios.post(url, form, config),
            cancel: () => cancelTokenSource.cancel(),
        }
    },
    update: (updates, opts, url, axiosConfig) => {
        const {config, cancelTokenSource} = getConfig(axiosConfig)
        addProgress(config, {...opts, hasStatic: true, noPercent: true})

        return {
            promise: axios.put(url, updates, config),
            cancel: () => cancelTokenSource.cancel(),
        }
    },
    get: (url, opts, axiosConfig) => {
        const {config, cancelTokenSource} = getConfig(axiosConfig)
        addProgress(config, {...opts, hasStatic: true, noPercent: true})
        return {
            promise: axios.get(url, config),
            cancel: () => cancelTokenSource.cancel(),
        }
    }
}
